import { render, staticRenderFns } from "./AffiliateFullCard.vue?vue&type=template&id=8ed03064&"
import script from "./AffiliateFullCard.vue?vue&type=script&lang=js&"
export * from "./AffiliateFullCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports